import React, { useState } from "react";
import Data from "../../assets/data/data";
import imag_1 from "../../assets/images/interior.jpg";
import { motion } from "framer-motion";
import Service from "../services/service";

const About = () => {
  const aboutFilteredData = Data.filter((item) => item.id === 3);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
      title: "A relax environment",
      content:
        "Its a space to celebrate happiness, friendship and love, filled with laughter, music and good food!.",
    },
    {
      title: "Superior value",
      content:
        "If you are looking for value for money, you are at the right place. We serve portion sizes that won’t leave you scrapping your plate.",
    },
    {
      title: "The Perfect Gateaway",
      content:
        "We strive to provide great ambience so you can spend the best time together and create memories. The dining experience becomes a magical experience and is the ideal place for a romantic meal for two, family lunch, or just a place to go for a bite to eat and a drink.",
    },
  ];
  return (
    <div>
      <section className="pt-14 px-5 sm:px-14 md:px-16 lg:px-20 pb-12">
        {aboutFilteredData.map((val, id) => (
          <div className="grid grid-cols-1 gap-6" key={id}>
            {val.facilities.map((value, id) => (
              <div
                key={id}
                className="grid grid-cols-1 md:grid-cols-12 lg:grid-cols-12 gap-6"
              >
                <div className="col-span-1 sm:col-span-1 md:col-span-4 lg:col-span-4">
                  <img
                    src={value.image}
                    alt="value.imge"
                    className="w-full object-cover h-96 rounded-md"
                  />
                </div>
                <div className="col-span-1 sm:col-span-1 md:col-span-8 lg:col-span-8">
                  <div className="font-bold font-fairDisplay text-4xl">
                    {value.title}
                  </div>
                  <div className="font-sans text-xl font-light text-gray-600 py-4 relative">
                    {value.discription}
                    <div className="after:absolute after:content-['.....'] after:bottom-[-10px] after:tracking-widest after:text-6xl"></div>
                  </div>
                  <div className="text-sm leading-6 text-gray-800 mt-5">
                    {value.details}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </section>
      <section className="bg-gray-300 pb-20">
        <Service />
      </section>
      <section className="pt-14 px-5 sm:px-14 md:px-16 lg:px-20">
        <div className="text-4xl font-semibold text-center font-fairDisplay relative">
          Why Choose Us
          <div className="after:absolute after:content-['........'] after:bottom-[-26px] after:right-[22%] md:after:right-[40%] lg:after:right-[46%] after:tracking-[0.2em] after:text-2xl"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 lg:grid-cols-12 gap-5 py-10">
          <div className="col-span-1 sm:col-span-1 md:col-span-4 lg:col-span-4">
            <img src={imag_1} alt="imag_1" className="w-full" />
          </div>
          <div className="col-span-1 sm:col-span-1 md:col-span-8 lg:col-span-8">
            {accordionData.map((item, index) => (
              <div key={index}>
                <div className="border border-gray-300 mb-3">
                  <button
                    className="w-full text-left px-4 py-3 flex justify-between items-center"
                    onClick={() => toggleAccordion(index)}
                  >
                    <span className="font-medium">{item.title}</span>
                    <span className="font-bold text-2xl">
                      {openIndex === index ? "-" : "+"}
                    </span>
                  </button>
                </div>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="px-4 py-3 bg-white text-gray-700 overflow-hidden"
                  >
                    {item.content}
                  </motion.div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
